import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { catchError, map } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';

import { handleError } from 'src/app/sdc/utils/error.handler';
import { api_url, TOKEN_EXPIRY, TOKEN_EXPIRY_SET_PASSWORD_FAILED } from '../utils/constants.helper';
import { LoginService } from './login.service';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SetPasswordService {
  apigee_url: string;

  constructor(
    private httpClient: HttpClient,
    private loginService: LoginService
  ) {
    this.apigee_url = environment.apigee_sdc_base_url;
  }

  updatePassword(passwordRequest: {password: string}): Observable<{ username: string }> {
    return this.httpClient
      .post<{ data: { username: string } }>(`${this.apigee_url}${api_url.UPDATE_PASSWORD}`, passwordRequest)
      .pipe(
        map((response) => response.data),
        catchError((e) => {
          const error = handleError(e).message;
          if (error === TOKEN_EXPIRY) {
            this.loginService.updateRedirectionCheck(TOKEN_EXPIRY_SET_PASSWORD_FAILED);
          }
          return throwError(() => error);
        })
      );
  }
}
